import PaymentSuccessful from "../../../Components/Client/PaymentSuccessful";

const PaymentSuccessfulPage = () => {
  return <PaymentSuccessful />;
};

export default PaymentSuccessfulPage;
